



























































import VerEditarModal from './VerEditarModal.vue';
import ModalVerHistorial from './ModalVerHistorial.vue';
import EditarGrilla from './EditarGrilla.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Component } from 'vue-property-decorator';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { fetchReportesSerie } from '@/pantallas/Conecta/MantenedorServipag/fetchReporteSerie';
import moment from 'moment';
import BuscadorMantenedor from '@/reusable/Grid/BuscadorMantenedor.vue';
import { ComponenteBase, Accion } from '@/views/base/ComponenteBase';
import { utils, writeFileXLSX } from 'xlsx';
import { actionsEvent } from '@/setup';
import {
  FormFieldDefMap,
  emitFormChangeEvent,
} from '@/reusable/Form/formUtils'; //plantilla
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { Funcionalidades } from '@/config/funcionalidades';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import { keys } from 'lodash';

@Component({
  components: {
    BuscadorMantenedor,
    EditarGrilla,
    VerEditarModal,
    MantenedorGridSinCodigo,
    ModalVerHistorial,
    FormFieldsContainer, //funcion que llamamos y ocupamos arriba
  },
})
export default class ConfigurarPantallaMotivo extends ComponenteBase {
  accionConsultar: PermisoAccion = { accionCodigo: 1, visible: false };
  accionEditar: PermisoAccion = { accionCodigo: 3, visible: false };

  accionesTotales: PermisoAccion[] = [this.accionConsultar, this.accionEditar];
  constructor() {
    super();
    actionsEvent.onEditar(this.handleEditarClick);
    actionsEvent.onVerHistorico(this.handleHistorialClick);
  }

  exportarExcel() {
    let informacionOrdenada = this.ordesList.map((e: any) => {
      return {
        Motivo: e.motiname,
        'Fecha Alta': moment(e.motifecha_alta).format('YYYY-MM-DD HH:mm:ss'),
        Estado: e.motibaja,
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Motivos_Baja');
    writeFileXLSX(wb, 'Motivos_Baja.xlsx');
    this.$snotify.success('Excel Exportado con éxito', 3000);
  }

  //llamamos a una clase para trabajar aqui dentro
  readonly funcionalidad: Funcionalidades = Funcionalidades.MotivodeBaja;
  ordesList: any[] = [];
  search: '';
  modalcrear: boolean = false;
  busquedaGrilla: string = '';
  filtrobusquedagrilla: string = '';
  Motivo: any;
  estado: any;
  motiid: any;
  diccionario = { t: 'INACTIVO', f: 'ACTIVO' };

  detalleSeleccionado: any = null;
  mostrarModalEditar: boolean = false;

  searchData() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }
  handleEditarClick(params: ICellRendererParams) {
    this.motiid = params.data.motiid;
    this.Motivo = params.data.motiname;
    this.estado = params.data.motibaja;
    this.mostrarModalEditar = true;
  }
  mostrarModalHistorial: boolean = false;
  handleHistorialClick(params: ICellRendererParams) {
    this.motiid = params.data.motiid;
    this.Motivo = params.data.motiname;
    this.mostrarModalHistorial = true;
  }
  async handleCierreModal() {
    this.ordesList = await this.getReportes();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    this.mostrarModalEditar = false;
    this.mostrarModalHistorial = false;
  }
  abrirmodal() {
    this.modalcrear = true;
  }

  async handleCierreModalVerDetalle() {
    this.modalcrear = false;
    this.ordesList = await this.getReportes();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');

    //this.handleBuscarClick();
  }

  //funcion para cargar la grilla
  async getReportes() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie({ '': '' }, 'MotivodeBaja')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  //grid (tabla)
  gridApi: GridApi = null;
  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Id',
        field: 'motiid',
        cellStyle: { textAlign: 'left' },
        width: 350,
        hide: true,
      },
      {
        headerName: 'Motivo',
        field: 'motiname',
        cellStyle: { textAlign: 'left' },
        width: 350,
      },
      {
        headerName: 'Fecha Alta',
        field: 'motifecha_alta',
        cellStyle: { textAlign: 'left' },
        width: 350,
        valueFormatter: function(params) {
          return moment(params.value).format('YYYY-MM-DD' + ' HH:mm:ss');
        },
      },

      {
        headerName: 'Estado',
        field: 'motibaja',
        cellStyle: { textAlign: 'left' },
        width: 350,

        cellRenderer: params => {
          return `<i class="material-icons" title="${
            params.data.motibaja
          }" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
            params.data.motibaja == 'INACTIVO' ? 'rgb(255, 58, 58)' : '#26FF26'
          }"></i>
          <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">
            ${params.data.motibaja}</a>`;
        },
      },
    ],

    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 50, //cantidad de datos a mostrar en inicio
    onGridReady: this.handleGridReady,
  };
  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getReportes();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }
}
